import * as XLSX from "xlsx";

export const convertToCSV = (rows) => {
  if (!rows.length) return "";
  const headers = Object.keys(rows[0]).join(",");
  const values = rows
    .map((row) =>
      Object.values(row)
        .map((v) => `"${v}"`)
        .join(",")
    )
    .join("\n");
  return `${headers}\n${values}`;
};

export const convertToTXT = (rows) =>
  rows
    .map((row) =>
      Object.entries(row)
        .map(([k, v]) => `${k}: ${v}`)
        .join("\n")
    )
    .join("\n\n");

export const downloadFile = (content, filename, mimeType) => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};

export const exportToCSV = (rows, filename = "DataSummary.csv") => {
  const content = convertToCSV(rows);
  if (!content) return;
  downloadFile(content, filename, "text/csv");
};

export const exportToTXT = (rows, filename = "DataSummary.txt") => {
  const content = convertToTXT(rows);
  if (!content) return;
  downloadFile(content, filename, "text/plain");
};

export const exportToExcel = (rows, filename = "DataSummary.xlsx") => {
  if (!rows.length) return;
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Summary");
  XLSX.writeFile(workbook, filename);
};

// Usage: Pass the company name (not ID) to this function for correct file naming.
export const downloadExportedScanTrackSummary = (
  response,
  format,
  companyName
) => {
  if (!response || !response.data) {
    throw new Error("No file received from server");
  }
  // Clean company name for file name (remove special chars, replace spaces with _)
  const CompanyName = companyName
    ? companyName.replace(/[^a-zA-Z0-9]/g, "_")
    : null;
  let fileName = CompanyName || "ScanTrackSummary";
  const currentDate = new Date();
  const dateString = currentDate.toISOString().split("T")[0];
  fileName += `_${dateString}`;
  let extension = format.toLowerCase();
  if (extension === "excel") extension = "xlsx";
  if (["csv", "txt", "xlsx"].includes(extension)) {
    fileName += `.${extension}`;
  }
  // Always use our custom fileName, ignore content-disposition header
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
